var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.data)?_c('div',{staticStyle:{"width":"100%","height":"90%"},attrs:{"init":_vm.updatafun(),"id":"Consumption"}}):_c('NoData')],1)}
var staticRenderFns = []

export { render, staticRenderFns }